var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55583 0C3.83057 0 0 3.83057 0 8.55583C0 13.2811 3.83057 17.1117 8.55583 17.1117C10.4309 17.1117 12.1651 16.5084 13.575 15.4855L17.8258 19.7362C18.1775 20.0879 18.7477 20.0879 19.0994 19.7362L19.7362 19.0994C20.0879 18.7477 20.0879 18.1775 19.7362 17.8258L15.4855 13.575C16.5084 12.1651 17.1117 10.4309 17.1117 8.55583C17.1117 3.83057 13.2811 0 8.55583 0ZM2.70184 8.55583C2.70184 5.32276 5.32276 2.70184 8.55583 2.70184C11.7889 2.70184 14.4098 5.32276 14.4098 8.55583C14.4098 11.7889 11.7889 14.4098 8.55583 14.4098C5.32276 14.4098 2.70184 11.7889 2.70184 8.55583Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.9ee5f90651c77dc3c9ddcd4e81beef1e.svg";
export { ForwardRef as ReactComponent };